import React from 'react'

import dashboardActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/dashboardActive.svg';
import dashboardIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/dashboardInactive.svg';
import analyticsActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/analyticsActive.svg';
import analyticsIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/analyticsInactive.svg';
import allowanceActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/allowanceActiveIcon.svg';
import allowanceIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/allowanceIcon.svg';
import reportAtiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/reportActive.svg';
import reportIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/reportInactive.svg';
import setupActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/setupActive.svg';
import setupIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/setupInactive.svg';
import geoLocationActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/locationActive.svg';
import geoLocationIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/locationInactive.svg';
import raughDraftIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/raughDraftInactive.svg';
import raughDraftActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/raughDraftActive.svg.svg';
import sittingActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/sittingActive.svg';    
import sittingIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/sittingInactive.svg';   
import queryActiveIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/queryActive.svg';
import queryIcon from '../../assets/PropertyProcurementAssets/HeaderIcons/queryInactive.svg';   

import advocatesIcon from '../../assets/PropertyProcurementAssets/Icons/advocatesIcon.svg';
import locationIcon from '../../assets/PropertyProcurementAssets/Icons/Interest & Source icon.svg';

import MajorQueryIcon from '../../assets/PropertyProcurementAssets/Icons/MajorQueryIcon.svg';
import MinorQueryIcon from '../../assets/PropertyProcurementAssets/Icons/MinorQueryIcon.svg';

const ProcurementImages = {
  dashboardActiveIcon,
  dashboardIcon,
  allowanceActiveIcon,
  allowanceIcon,
  analyticsActiveIcon,
  analyticsIcon,
  reportAtiveIcon,
  reportIcon,
  setupActiveIcon,
  setupIcon,
  geoLocationActiveIcon,
  geoLocationIcon,
  raughDraftIcon,
  raughDraftActiveIcon,
  sittingActiveIcon,
  sittingIcon,
  queryActiveIcon,
  queryIcon,


  advocatesIcon,
  locationIcon,
  MajorQueryIcon,
  MinorQueryIcon



 
  
};

export default ProcurementImages